<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <div class="col-md-12">
      <the-filters
        :filters="computedFilters"
        :showCleareble="showRedefine"
        @get-model="getFiltersModel"
        @on-cleareble="resetService"
        @search="searchItems"
      />
      <the-table
        id="service-list"
        :dataItems="computedServices"
        :headers="headersForTable"
      >
        <template v-slot:hStatus>
          <span class="d-flex justify-content-center">Status</span>
        </template>
        <template v-slot:status="{item}">
          <!-- <span class="d-block">{{item.status}}</span> -->
          <div style="display:flex; justify-content:center;">
          <small class="status_info" :style="`color: white; padding: 5px 10px; border-radius: 10px; background-color:${returnColorForStatus(item.status)}`">{{item.status}}</small>
          </div>
        </template>
        
        <template v-slot:countAnimals>
          <span class="d-flex justify-content-center">Animais</span>
        </template>
        <template v-slot:count_animals="{item}">
          <a 
            class="text-link" 
            style="color:var(--medium-blue) !important"
            @click="openAnimalsModal(item)"
          >{{item.service_animals_count}}</a>
        </template>

        <template v-slot:wrongAnimals>
          <span class="d-flex justify-content-center">Animais Incorretos</span>
        </template>
        <template v-slot:incorret_animals="{item}">
          <a 
            class="text-link" 
            style="color:var(--medium-blue) !important"
            @click="openAnimalsModalIncorrect(item)"
          >{{item.incorret_animals_count}}</a>
        </template>

        <template v-slot:actions="{item}">
          <span class="p-1 d-flex align-items-center">
            <i 
              class="mdi mdi-eye icon"
              v-tooltip.top="'Detalhes'"
              @click="showDetailsFunction(item)"
            ></i>

            <i 
              v-if="user.attributes.kind === 'admin'"
              class="mdi mdi-pencil icon px-2"
              v-tooltip.top="'Editar'"
              @click="$router.push({name:'Milk-analysis', params:{id:item.id} })"
            ></i>

            <i 
              v-if="user.attributes.kind === 'admin'"
              class="mdi mdi-delete icon"
              v-tooltip.top="'Deletar'"
              @click="openAlertModal(item)"
            ></i>
          </span>
        </template>
      </the-table>

      <div class="col-md-12 d-flex justify-content-end">
        <v-pagination
          v-if="computedPagination ? computedPagination.total_pages > 1 : 0"
          v-model="page"
          :length="computedPagination ? computedPagination.total_pages : 0"
          color="var(--medium-blue)"
        ></v-pagination>
      </div>
    </div>

    <modal-analysis 
      :active="showDetails"
      :service="animalsDetails"
      @close="showDetails = false"
    />
    
    <alert-modal 
      :open="alertModal"
      @delete="deleteMilkAnalysis"
      @close="alertModal = false"
    />
  </div>
</template>

<script>
import TheTable from "@/components/layout/TheTable";
import TheFilters from "@/components/layout/TheFilters";
import validations from "@/mixins/validations.js";
import helpers from "@/mixins/helpers.js";
import {mapState, mapActions} from "vuex";
import openAuthenticatedPdf from "@/http/openPdf";
export default {
  name:"MilkList",
  components: {
    TheTable,
    TheFilters,
    ModalAnalysis: () => import("./ModalAnalysis"),
    AlertModal: () => import("./AlertModal")
  },
  mixins:[validations, helpers],
  data() {
    return {
      showDetails:false,
      alertModal:false,
      serviceToDelete:{},
      animalsDetails:{},
      headersForTable:[
        {text:"Código Serviço", value:"code", sortable:true, type:"number"},
        {text:"Status", value:"status", has_slot:true, header_slot:"hStatus", sortable:true},
        {text:"Controlador", value:"partner", sortable:true},
        {text:"Criador", value:"person", sortable:true},
        {text:"Data Emissão", value:"date_emission", sortable:true},
        {text:"Gord", value:"fat"},
        {text:"Prot", value:"protein"},
        {text:"Lact", value:"lactose"},
        {text:"Sólidos Totais", value:"solids"},
        {text:"Ureia", value:"urea"},
        {text:"CCS", value:"ccs"},
        {text:"Ações", value:"actions", has_slot:true}
      ],
      query:{},
      list:[],
      page:1,
      showRedefine:false,
      openModalAnimals:false,
      dataForAnimalsModal:{}
    }
  },
  computed: {
    ...mapState("service", ["services","pagination"]),
    ...mapState("login", ["user"]),
    ...mapState("creators", ["creators"]),
    ...mapState("partners", ["partners"]),
    //Essa computed devolve os filtros do componente
    computedFilters() {
      let result = [
        {name:"code", type:"text", label:"Código Serviço"},
        {name:"partner", type:"select", label:"Controlador", items:this.partners},
        {name:"person", type:"select", label:"Criador", items:this.creators},
      ];
      if(this.user.attributes.kind === 'partner') {
        result.splice(1, 1);
      }
      return result;
    },
    computedPagination() {
      if(this.pagination) {
        return this.pagination
      } 
      else {
        return false
      }
    },
    canDelete() {
      let finded = this.user.roles.find(e => e.name === "service.destroy");
      if(finded) {
        return true;
      } else {
        return false;
      }
    },
    computedServices: {
      get() {
        // fat/protein/lactose/urea/ccs e as contagens vêm prontos do summary (medias no back)
        return this.services
          .map(e => ({
            ...e,
            code:e.code,
            person:e.person && e.person.name ? e.person.name : "-",
            partner:e.partner && e.partner.name ? e.partner.name : "-",
            date_emission:e.date_emission,
            date_close:typeof e.date_close === "string" && e.date_close.trim() ? e.date_close : e.status,
          }));
      },
      set(newValue) {
        this.services = newValue;
      }
    }
  },
  methods: {
    ...mapActions("service", [
      "actionGetServices",
      "actionGetSingleService",
    ]),
    ...mapActions("creators", [
      "actionGetCreators"
    ]),
    ...mapActions("partners", [
      "actionGetPartners"
    ]),
    ...mapActions("milk_control", [
      "actionDeleteMilkControl"
    ]),
    async deleteMilkAnalysis() {
      try {
        await this.actionDeleteMilkControl(this.serviceToDelete);
        this.$toast.success("Análise excluída com sucesso!");
        await this.loadServices(1);
        this.alertModal = false;
      } catch(error) {
        this.$toast.error(error);
      }
    },
    openAlertModal(item) {
      this.serviceToDelete = item;
      this.alertModal = true;
    },
    //metodo a seguir calcula a media de lactação dos animais do serviço
    averageCalculator(attr, array) {
      const values = Array.isArray(array)
        ? array.map(e => parseFloat(e[attr])).filter(Number.isFinite)
        : [];
      if(!values.length) return "-";

      return (values.reduce((total, value) => total + value, 0) / values.length).toFixed(2);
    },
    //esse metodo controla a modal de detalhes 
    async showDetailsFunction(item) {
      const full = await this.actionGetSingleService(item.id);
      this.animalsDetails = full || item;
      this.showDetails = true;
    },
    //Esse função recebe e seta os items de query de busca
    getFiltersModel(data) {
      this.query[data.title] = data.value
    },
    async loadServices(page = this.page) {
      await this.actionGetServices({...this.query, page, status:"classified", summary:true});
    },
    handleEnterKeypress(e) {
      if(e.key === "Enter" && Object.keys(this.query).length > 0) {
        this.searchItems();
      }
    },
    //Essa função faz o get dos items da tabela conforme os filtros
    async searchItems() {
      const {code, partner, person, status} = this.query;
      if(code || partner || person || status) {
        this.showRedefine = true;
        if(this.page === 1) {
          await this.loadServices(1);
        } else {
          this.page = 1;
        }
      } else {
        this.$toast.warning("Informe ao menos um filtro de pesquisa !");
      }
    },
    //Esse metodo é especifico para resetar os item iniciais de serviço
    async resetService() {
      this.query = {};
      this.showRedefine = false;
      if(this.page === 1) {
        await this.loadServices(1);
      } else {
        this.page = 1;
      }
    },
    //Esse metodo importa o pdf do serviço
    importPdf(service) {
      const url = `${process.env.VUE_APP_URL_API}/v1/services/${service.id}/pdf`
      openAuthenticatedPdf(url).catch(() => this.$toast.error("Não foi possível abrir o PDF"))
    },
    //Esse metodo retorna a cor do status 
    returnColorForStatus(status) {
      if(status === "Em preenchimento") {
        return "#56707a" //dark grey
      }
      if(status === "Pendente") {
        return "#1f6fd1" // azul
      } 
      if(status === "Fechado") {
        return "#127a5c" // verde-azulado
      }      
      if(status === "Validado") {
        return "#2e7d32" // verde
      }
      if(status === "Classificado") {
        return "#9044eb" // purple (mesma cor da lista de Serviços)
      }
      else {
        return "#b45f06" // laranja - Finalizado
      }
    },
    //Esse metodo vai ler e retornar o id (criado pelo front) para passar para a api na busca
    returnStatusId(status) {
      if(status === "Pendente") {
        return "pending";
      }
      if(status === "Finalizado") {
        return "close"
      }
      if(status === "Em preenchimento") {
        return "open"
      }
      if(status === "Parcialmente Aprovado") {
        return "unaproved"
      }
    },
    //Esse metodo vai abrir o modal de animais do serviço
    async openAnimalsModal(service) {
      const full = await this.actionGetSingleService(service.id);
      const animals = full && Array.isArray(full.service_animals) ? full.service_animals : [];
      this.dataForAnimalsModal = {code:service.code, animals:animals.map(e => ({...e.animal, regime:e.regime}))};
      this.openModalAnimals = true;
    },
    async openAnimalsModalIncorrect(service) {
      const full = await this.actionGetSingleService(service.id);
      const animals = full && Array.isArray(full.incorret_animals) ? full.incorret_animals : [];
      this.dataForAnimalsModal = {code:service.code, animals:animals.map(e => ({...e.animal, regime:e.regime}))};
      this.openModalAnimals = true;
    },
  },
  async mounted() {
    document.addEventListener("keypress", this.handleEnterKeypress);
    await this.loadServices(1);
    await this.actionGetCreators();
    await this.actionGetPartners();
  },
  beforeDestroy() {
    document.removeEventListener("keypress", this.handleEnterKeypress);
  },
  watch: {
    async page(val) {
      await this.loadServices(val)
    }
  }
}
</script>

<style scoped>
  .icon {
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--medium-blue);
  }
</style>
